import * as React from 'react';
import * as style from './emailTooltip.css';

import { TooltipPopup } from '../../../../../common/components/tooltip_popup';

interface IEmailTooltipProps {
  isTooltipOpen: boolean;
  handleTooltipIconClick(): void;
  handleTooltipePopupClose(): void;
}

export function EmailTooltip(props: IEmailTooltipProps) {
  const { isTooltipOpen, handleTooltipIconClick, handleTooltipePopupClose } = props;

  return (
    <div className={style['label']}>
      <span className={style['label-text']}>Ваш email</span>
      <div className={style['tooltip-container']}>
        <div className={style['tooltip-icon']} onClick={handleTooltipIconClick} />
        <TooltipPopup
          open={isTooltipOpen}
          handlePopupClose={handleTooltipePopupClose}
          containerClass={style['tooltip']}
          direction="left"
        >
          {/* tslint:disable-next-line:no-irregular-whitespace */}
          Для получения уведомлений  о новых объявлениях
        </TooltipPopup>
      </div>
    </div>
  );
}
